module.exports = {
  AMBIO: 'Ambio Wireless Scale',
  WITHINGS: 'WITHINGS',
};
